import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './FavoritesIndicator.module.scss';

interface FavoritesIndicatorProps {
  favorited?: boolean;
  showText?: boolean;
}

const FavoritesIndicator: FC<FavoritesIndicatorProps> = ({
  favorited = false,
  showText = false,
}) => {
  const getFavoritesIndicatorClasses = () =>
    classNames({
      [styles.favoritesIndicator]: true,
      [styles.favoritesIndicatorFavorited]: favorited,
      [styles.favoritesIndicatorShowText]: showText,
      [styles.favoritesIndicatorShowTextFavorited]: showText && favorited,
      'quiver-favorites-indicator': true,
    });

  return (
    <div className={getFavoritesIndicatorClasses()} data-testid="favorites-indicator">
      <svg className={styles.icon}>
        <g>
          <circle cx="16" cy="16" r="16" />
          <polygon
            points="16 8, 18.5 13, 24 14, 20 18, 21 23, 16 20, 11 23, 12 18, 8 14, 13.5 13"
            strokeLinejoin="round"
          />
        </g>
      </svg>
      {showText ? (
        <div className={styles.text}>{favorited ? 'Favorited' : 'Add Favorite'}</div>
      ) : null}
    </div>
  );
};

export default FavoritesIndicator;
